module.exports = __webpack_public_path__ + "img/form-success.99903dd.png";